import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Criteria',
  name: 'trialCriteria',
  type: 'multiSelect',
  selected: null,
  selectedVal: [],
};

const storeName = 'trialCriteria';
export const useTrialCriteriaFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateTrialCriteriaFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'trialCriteria' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateTrialCriteriaFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'trial_criteria', action: 'select', item_id: value }, '87ec2b65-60aa-4485-a0cd-de37518ecd87');
  }
  setFilterValue(useTrialCriteriaFilter, option);
};
export const clearTrialCriteriaFilterOption = () => {
  useTrialCriteriaFilter.setState({ ...initialState }, false, {
    type: 'clearTrialCriteriaFilterOption',
  });
};
